<template>
  <customModal :containerlg="true" @closeModal="closeModal">
    <template #title> QTL Details - {{ data?.ctqid }} </template>

    <template #body>
      <div class="modal-scroll-body">
        <!-- Loading -->
        <div
          class="d-flex justify-content-center align-items-center py-5"
          v-if="loading"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- No Data -->
        <div class="text-center py-5" v-else-if="!qtlList.length">
          <p class="text-muted">No QTL data available</p>
        </div>

        <!-- Table Content -->
        <div v-else>
          
          <div class="table-responsive" style="overflow-x: auto;">
            <div class="ibox-title style_2 d-flex justify-content-between">
               <h5 class="m-0">Quality Tolerance Limits (QTLs)</h5>
               <div class="position-relative align-self-center">
                 <img
                   src="@/assets/img/create.png"
                   width="17"
                   alt="Add QTL"
                   style="cursor: pointer"
                   @click="openManageQTLModal()"
                 />
                 <div class="tool-tip">Add QTL</div>
               </div>
            </div>
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>QTL ID</th>
                  <th>Critical Factor</th>
                  <th>CTQ Category</th>
                  <th>Description</th>
                  <th>Quality Metric</th>
                  <th>Acceptable Limits</th>
                  <th>Responsible Owner</th>
                  <th>Monitoring Frequency</th>
                  <th class="text-center">Edit</th>
                  <th class="text-center">View</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in qtlList" :key="item.id">
                  <td>
                    <span>{{ item.qtlId }}</span>
                  </td>
                  <td style="max-width: 320px; white-space: normal; word-break: break-word;">
                    <span>{{ item.expanded ? item.ctqFactor : (item.ctqFactor || '').slice(0, 60) }}</span>
                    <a
                      v-if="(item.ctqFactor || '').length > 60"
                      class="more-less-link ms-1"
                      @click.stop="toggleExpand(item)"
                    >
                      {{ item.expanded ? 'less' : 'more' }}
                    </a>
                  </td>
                  <td>{{ item.ctqCategory }}</td>
                  <td style="max-width: 320px; white-space: normal; word-break: break-word;">
                    <span>{{ item.expanded ? item.qtlDescription : (item.qtlDescription || '').slice(0, 60) }}</span>
                    <a
                    v-if="(item.qtlDescription || '').length > 60"
                    class="more-less-link ms-1"
                    @click.stop="toggleExpand(item)"
                    >
                    {{ item.expanded ? 'less' : 'more' }}
                    </a>
                  </td>
                  <td>{{ item.qualityMetric }}</td>
                  <td style="max-width: 320px; white-space: normal; word-break: break-word;">
                    <span>{{ item.expanded ? item.qtlAcceptableLimits : (item.qtlAcceptableLimits || '').slice(0, 60) }}</span>
                    <a
                      v-if="(item.qtlAcceptableLimits || '').length > 60"
                      class="more-less-link ms-1"
                      @click.stop="toggleExpand(item)"
                    >
                      {{ item.expanded ? 'less' : 'more' }}
                    </a>
                  </td>
                  <td>{{ item.responsibleOwner }}</td>
                  <td>{{ item.monitoringFrequency }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      @click="openManageQTLModal(item)"
                    >
                    </i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      @click="viewQTLDetails(item)"
                    >
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mx-0 mt-3" v-if="totalPages > 1">
            <div class="col-12 d-flex justify-content-end">
              <VPagination
                v-model="currentPage"
                :pages="totalPages"
                :range-size="1"
                active-color="#618bd7"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
  <QTLDetailsModal
    v-if="showQTLDetailsModal"
    :data="selectedQTLItem"
    @closeModal="closeQTLDetailsModal"
  />
  <manageQtlModal
    v-if="openCreateQtlModal"
    :qtlEditData="qtlEditData"
    @closeModal="closeQtlModal"
    @reloadList="reloaddatagrid"
  />
</template>

<script src="./QtlInfoModal.js"></script>

<style scoped>

.more-less-link {
  color: #5b9bd5 !important;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
}

.more-less-link:hover {
  text-decoration: underline !important;
}

.badge {
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 500;
  display: inline-block;
  white-space: nowrap;
}

.modal-scroll-body {
  padding: 10px 0;
  max-height: 60vh;
  overflow-y: auto;
}
.position-relative .tool-tip {
  top: 0px;
  right: 18px;
}
.ibox-title.style_2 {
  padding: 8px 15px  !important;
  min-height: 34px;
}

:deep(.iframe-container) {
  width: 90vw !important;
  max-width: 90vw !important;
}
</style>